import { requestInfoHeaderListColumns, requestInfoParamsListColumns, responseInfoParamsListColumns, statusCodeListColumns, urlParamsColumns } from './column.js';
export default {
  name: 'VDesc',
  components: {},
  props: {
    interfaceDetail: Object,
    titleList: Array
  },
  data() {
    return {
      requestInfoHeaderListColumns,
      responseInfoParamsListColumns,
      requestInfoParamsListColumns,
      statusCodeListColumns,
      urlParamsColumns,
      activeIndex: 0
    };
  },
  computed: {
    activeKey: {
      get() {
        const arr = this.titleList.map(item => item.key);
        return arr;
      },
      set(val) {
        return val;
      }
    },
    customStyle() {
      return 'background: #fff;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden';
    }
  },
  created() {
    // console.log(this.interfaceDetail, 'pp');
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 判端滚动位置
    handleScroll() {
      let scrollPosition = Math.floor(window.scrollY || document.documentElement.scrollTop);
      let pageHeight = Math.floor(document.documentElement.scrollHeight || document.body.scrollHeight);
      let list = document.querySelectorAll('.author');
      list.forEach((item, index) => {
        // console.log(scrollPosition, item, item.offsetTop, 'pp');
        if (scrollPosition + 64 >= item.offsetTop) {
          this.activeIndex = index;
        }
      });
      this.$emit('scrollTitle', this.titleList[this.activeIndex].key);
      if (scrollPosition + window.innerHeight + 20 >= pageHeight) {
        // 滚动到底部了
        this.$emit('scrollTitle', this.titleList[this.titleList.length - 1].key);
      }
    }
  },
  watch: {},
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};